import React, { memo } from 'react';
import { View } from 'react-native';
import { useSize } from './context';
import MonthCell from './MonthCell';
import WeekBar from './WeekBar';
import DateGroup from './DateGroup';
import HolidayBar from './HolidayBar';
import LegendBar from './LegendBar';
/**
 * Month component for displaying single month visual:
 *
 * Juni 2022               < >  –> MonthCell
 * Sen Sel Rab Kam Jum Sab Min  –> WeekBar
 *          1   2   3   4   5   –> DateGroup
 *  6   7   8   9   10  11  12
 *  13  14  15  16  17  18  19
 *  20  21  22  23  24  25  26
 *  27  28  29  30
 * [13 Cuti Bersama]            –> Footer Cells
 */
function Month(props) {
    const { width } = useSize();
    const { year, month, firstDay, horizontal, minDate, maxDate, onPrevMonthPress, onNextMonthPress, onLayout, hideArrows, colorConfig, todayLabel, hideHolidayBadges, hideLegendBadges, dayColor, } = props;
    return (<View style={{ width }} onLayout={onLayout}>
      <MonthCell year={year} month={month} horizontal={horizontal} minDate={minDate} maxDate={maxDate} onPrevMonthPress={onPrevMonthPress} onNextMonthPress={onNextMonthPress} hideArrows={hideArrows}/>
      <WeekBar firstDay={firstDay} dayColor={dayColor}/>
      <DateGroup year={year} month={month} firstDay={firstDay} minDate={minDate} maxDate={maxDate} colorConfig={colorConfig} todayLabel={todayLabel}/>
      {!hideHolidayBadges && <HolidayBar horizontal={horizontal} year={year} month={month}/>}
      {!hideLegendBadges && <LegendBar horizontal={horizontal} year={year} month={month}/>}
    </View>);
}
export default memo(Month);
